export const MIN_QUANTITY_SERVICES_WITH_ONLINE_APPOINTMENT = 20
